import React from 'react';

const ButtonComponent = ({ onClick, disabled, children, buttonClass }) => (
    <button className={buttonClass} onClick={onClick} disabled={disabled}>
        {children}
    </button>
);

export default ButtonComponent;